import React, { useEffect, useState } from 'react';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import SwipeRightOutlinedIcon from '@mui/icons-material/SwipeRightOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import ManageHistoryOutlinedIcon from '@mui/icons-material/ManageHistoryOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import { getDashboardCardCount } from '../../api/casp/dashboard';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';

const DashboardStatics = ({ projectId, t }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [dashboardCardcount, setDashboardCardcount] = useState();
    useEffect(() => {
        if (projectId) {
          fetchProjectCardsCount();
        }
      }, []);

      const fetchProjectCardsCount = async () => {
        try {
          setIsLoading(true);
          const cardCount = await getDashboardCardCount(projectId);
          setDashboardCardcount(cardCount.data.data)
        } catch (error) {
          console.log(error);
          toast.error(error.message);
        } finally {
          setIsLoading(false);
        }
      };

    const DashStats = [
        {
            icon: <AssignmentTurnedInOutlinedIcon />,
            iconBgColor: "#DCECFF",
            iconColor: "#316BE8",
            statCount: dashboardCardcount?.tickets,
            statText: t("Tasks"), 
        },
        {
            icon: <SwipeRightOutlinedIcon />,
            iconBgColor: "#E5FFF1",
            iconColor: "#0ABA5B",
            statCount: dashboardCardcount?.changeRequests,
            statText: t("Change Request")
        },
        {
            icon: <PeopleOutlineOutlinedIcon />,
            iconBgColor: "#E7E3FF",
            iconColor: "#6F61C4",
            statCount: dashboardCardcount?.teams,
            statText: t("Teams")
        },
        {
            icon: <FileCopyOutlinedIcon />,
            iconBgColor: "#CAF2FF",
            iconColor: "#0B8FBB",
            statCount: dashboardCardcount?.documents,
            statText: t("Documents")
        },
        {
            icon: <ManageHistoryOutlinedIcon />,
            iconBgColor: "#E5FFC4",
            iconColor: "#6DBE07",
            statCount: dashboardCardcount?.challenges,
            statText: t("Challenges")
        },
        {
            icon: <PersonOutlinedIcon />,
            iconBgColor: "#FFE8E8",
            iconColor: "#FF8080",
            statCount: dashboardCardcount?.stakeholders,
            statText: t("Offtakers")
        },
    ]
    return(
        <div className="dashboardCardStats">
            {!isLoading && DashStats.map((item, index) => (
                <div className="card" key={index}>
                    <div className='statCardWrapper d-flex'>
                        <div className='iconBox me-2' style={{backgroundColor: item.iconBgColor, color: item.iconColor }}>{item.icon}</div>
                        <div className='statWrapper'>
                            <div className='statCount'>{item.statCount}</div>
                            <div className='statText'>{item.statText}</div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default withTranslation() (DashboardStatics)
